import { apiClient } from '../utils/api-client'

/** Minimal public summary returned by a coach's invite link. */
export interface CoachSummary {
  id: string
  username: string
  full_name: string | null
  avatar_medium_url: string | null
  avatar_small_url: string | null
}

interface CoachResponse {
  data: { id: string; type: string; attributes: Omit<CoachSummary, 'id'> }
}

class CoachesService {
  /** Resolve a coach from the secret token in their shareable invite link. */
  async get(token: string): Promise<CoachSummary> {
    const response = await apiClient.get(`/api/coaches/${token}`)
    if (!response.ok) {
      throw new Error(`Coach not found: ${response.status}`)
    }
    const json: CoachResponse = await response.json()
    return { ...json.data.attributes, id: json.data.id }
  }
}

export const coachesService = new CoachesService()
